import {Project} from "./project";
import {Board} from "../components/admin/components/colorboard/models";
import {Trade} from "./trade";

export class Company {
  id: number;
  name: string;
  subdomain: string;
  address1: string;
  address2: string;
  state: string;
  city: string;
  zipCode: string;
  email: string;
  countryCode: string;
  phoneNumber: string;
  users: string;
  type: CompanyType;
  style: CompanyStyle;
  usersCount: number;
  tradeUsersCount: number;
  tradeUsersNumberAllowed: number;
  projects: Project[]= [];
  trades: Trade[] = [];
  colorBoards: Board[]= [];
  version: number;
  companyPlan: CompanyPlan;
  projectsCount: number;
  projectsNumberAllowed: number
}

export enum CompanyType {
  CABINETS="CABINETS",
  ELECTRICAL="ELECTRICAL",
  FLOORING="FLOORING",
  FRAMING="FRAMING",
  GENERAL_CONTRACTOR="GENERAL_CONTRACTOR",
  HOTEL="HOTEL",
  HVAC="HVAC",
  MECHANICAL="MECHANICAL",
  MILLWORK="MILLWORK",
  LOW_VOLTAGE="LOW_VOLTAGE",
  PAINTING="PAINTING",
  PLUMBING="PLUMBING",
  TILING="TILING"
}

export class CompanyPlan {
  id: number;
  planName: string;
  minUsers: number;
  maxUsers: number;
}


export class Country {
  name: string;
  dial_code: string;
  code: string;
}

export enum CompanyStyle {
  SOLO = 'SOLO',
  TRADES = 'TRADES',
}
